<template>
	<div class="productAndservice">
		<!-- <div class="backgroundImage"></div> -->
		<img  style="width: 100%;" class="bannerImg" :src="bgUrl" />
		<div class="shell" :style="{ height: screenheight }">
			<div class="form">
				<el-form ref="form" :rules="rules" :model="form" label-width="0px" size="mini">
					<el-form-item prop="enterpriseName"><el-input placeholder="企业名称"  v-model="form.enterpriseName"></el-input></el-form-item>
					<el-form-item label-width="150" label="企业类型">
						<el-radio v-model="form.type" label="1">服务商</el-radio>
						<el-radio v-model="form.type" label="2">药企</el-radio>
					</el-form-item>
					<el-form-item prop="contacts"><el-input  placeholder="姓名" v-model="form.contacts"></el-input></el-form-item>
					<el-form-item prop="tel"><el-input  placeholder="手机号" v-model="form.tel"></el-input></el-form-item>
					<div class="flex-row form1">
						<el-form-item prop="verificationCode"><el-input  placeholder="验证码" v-model="form.verificationCode"></el-input></el-form-item>
						<el-form-item>
							<div @click="refreshCode" class=" verificationCode flex-row flex-center"><verification-code :identifyCode="identifyCode"></verification-code></div>
						</el-form-item>
					</div>
					<el-form-item><p>*我们将于1个工作日内与您取得联系</p></el-form-item>
					<el-form-item><el-button type="primary" @click="onSubmit">免费体验</el-button></el-form-item>
				</el-form>
			</div>
		</div>

		<ecology class="wow slideInUp" id="ecology"></ecology>
		<introduce class="wow slideInUp" id="introduce" :isFixed="isFixed"></introduce>
		<case class="wow slideInUp" id="case"></case>
		<yxtInfo class="wow slideInUp" id="yxtInfo"></yxtInfo>
	</div>
</template>

<script>
import { WOW } from 'wowjs';
import Ecology from './components/ecology.vue';
import Introduce from './components/introduce.vue';
import Case from '@/views/home/components/case.vue';
import YxtInfo from '@/views/home/components/yxtInfo.vue';
import { addapply } from '@/api/addapply/addapply.js';
import VerificationCode from '../freeTrial/components/verificationCode.vue';
export default {
	components: {
		Ecology,
		Introduce,
		Case,
		YxtInfo,
		VerificationCode
	},
	data() {
		var checkTel = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			}
			var num_reg = /^13[0-9]{1}[0-9]{8}$|15[0-9]{1}[0-9]{8}$|16[0-9]{1}[0-9]{8}$|18[0-9]{1}[0-9]{8}|17[0-9]{1}[0-9]{8}$|19[0-9]{1}[0-9]{8}$|14[0-9]{1}[0-9]{8}/;
			if (!num_reg.test(value)) {
				callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		var checkVerificationCode = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('验证码不能为空'));
			}
			if (this.identifyCode.toLowerCase() != value.toLowerCase()) {
				callback(new Error('验证码错误'));
			} else {
				callback();
			}
		};
		return {
			isFixed: false, //是否浮动
			oldScrollTop:0,
			identifyCode: '',
			identifyCodes: [
				'0',
				'1',
				'2',
				'3',
				'4',
				'5',
				'6',
				'7',
				'8',
				'9',
				'A',
				'a',
				'B',
				'b',
				'C',
				'c',
				'D',
				'd',
				'E',
				'e',
				'F',
				'f',
				'G',
				'g',
				'H',
				'h',
				'I',
				'i',
				'J',
				'j',
				'K',
				'k',
				'L',
				'l',
				'M',
				'm',
				'N',
				'n',
				'O',
				'o',
				'P',
				'p',
				'Q',
				'q',
				'R',
				'r',
				'S',
				's',
				'T',
				't',
				'U',
				'u',
				'V',
				'v',
				'W',
				'w',
				'X',
				'x',
				'Y',
				'y',
				'Z',
				'z'
			], 
			form: {
				contacts: '',
				tel: '',
				enterpriseName: '',
				job: '',
				source: '药销通官网',
				type: '1',
				yourRequirements: '',
				verificationCode: ''
			},
			rules: {
				enterpriseName: [{ required: true, message: '请输入公司名称', trigger: ['change', 'blur'] }],
				contacts: [{ required: true, message: '请输入联系人', trigger: ['change', 'blur'] }],
				tel: [{ validator: checkTel, trigger: ['change', 'blur'] }],
				verificationCode: [{ validator: checkVerificationCode, trigger: ['change', 'blur'] }]
			},
			screenheight: '712px',
			wow: '',
			bgUrl: require('@/assets/productAndservice/banner1.png')
		};
	},
	mounted() {
		this.$nextTick(() => {
			// 在dom渲染完后,再执行动画
			this.wow = new WOW({
				live: false,
				offset: 100
			});
			this.wow.init();
		});
		this.refreshCode();
		window.addEventListener('scroll', this.scrolling);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrolling);
	},

	methods: {
		onSubmit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					addapply(this.form).then(({ data: res }) => {
						if (res.data) {
							this.$message({
								message: '恭喜你，申请成功，稍后会有专人与您联系',
								type: 'success'
							});
							this.refreshCode();
						} else {
							this.$message({
								message: res.msg,
								type: 'warning'
							});
						}
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}, // 生成随机数
		randomNum(min, max) {
			max = max + 1;
			return Math.floor(Math.random() * (max - min) + min);
		},
		// 更新验证码
		refreshCode() {
			this.identifyCode = '';
			this.makeCode(this.identifyCodes, 4);
		},
		// 随机生成验证码字符串
		makeCode(data, len) {
			for (let i = 0; i < len; i++) {
				this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)];
			}
		},
		scrolling() {
			var odiv = document.getElementById("introduce");
			// 滚动条距文档顶部的距离
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// 滚动条滚动的距离
			let scrollStep = scrollTop - this.oldScrollTop;
			// 更新——滚动前，滚动条距文档顶部的距离
			this.oldScrollTop = scrollTop;
			//变量windowHeight是可视区的高度
			let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
			//变量scrollHeight是滚动条的总高度
			let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
			//滚动条向上滚动
			// if (scrollTop < odiv.offsetTop+100) {
			// 	console.log("错")
			// 	this.isFixed = false;
			// } else {
			// 	console.log("对")
			// 	this.isFixed = true;
			// }
			// // 判断是否到了最顶部
			// if (scrollTop <= 0) {
			// 	this.isTransparent = true;
			// }
			// if (scrollTop - 150 <= 0) {
			// }
		},
		
	}
};
</script>

<style lang="scss" scoped>
	.backgroundImage{
		width: 100%;
		height: 712px;
		background-image: url('../../assets/productAndservice/banner1.png');
		background-repeat: no-repeat;
	}
.shell {
	position: absolute;
	width: 1200px;
	top: 0;
	left: calc(50% - 600px);
}
.form {
	position: absolute;
	top: calc(50% - 250px);
	right: 0;
	z-index: 99;
	width: 451px;
	height: 550px;
	background: #ffffff;
	box-shadow: 0px 0px 22px 0px rgb(0 0 0 / 18%);
	border-radius: 8px;
	.form1 {
		justify-content: space-between;
		.el-form-item::v-deep {
			width: 49%;
		}
	}
	.verificationCode {
		align-items: center;
		padding-top: 10px;
		width: 100%;
		height: 52px;
		border: 1px solid #dcdfe6;
	}
}
.el-input__inner {
	height: 52px !important;
	line-height: 28px;
}
.el-input::v-deep {
	.el-input__inner {
		height: 52px;
		line-height: 52px;
		font-size: 14px !important;
	}
}
.el-form-item--mini.el-form-item {
	margin-bottom: 20px;
}
.el-form {
	margin: 0 auto;
	margin-top: 53px;
	width: 357px;
	height: 80%;
	p {
		padding-left: 15px;
		font-size: 12px;
		font-weight: 400;
		color: #666666;
		line-height: 0px;
	}
	.el-button {
		width: 357px;
		height: 44px;
		border-radius: 2px;
	}
}
</style>
